module.exports = __webpack_public_path__ + "img/Y2KYYP2.7da939b5.jpg";